/* Custom multilingual cookie-consent banner.
   Records the visitor's choice through Shopify's Customer Privacy API, so
   Shopify's Consent Mode keeps gating analytics/marketing pixels exactly as it
   did with the built-in banner. We only render our own UI (in the storefront
   language); the enforcement stays with Shopify.

   Show logic — show only when BOTH are true:
     1. The region requires consent  → cp.isRegulationEnforced() (fallback shouldShowBanner()).
     2. The visitor hasn't decided yet → our own localStorage flag is unset AND
        no explicit consent is already recorded (accepted anything, or fully declined).
   Note: cp.shouldShowBanner() keeps returning true even AFTER a decline, so it
   can't be used on its own — it would re-nag visitors who already chose. */
(() => {
  if (customElements.get('ivb-cookie-consent')) return;

  var CHOICE_KEY = 'ivb_cookie_choice';

  class IvbCookieConsent extends HTMLElement {
    connectedCallback() {
      this.withApi((cp) => this.init(cp));
    }

    withApi(cb) {
      var S = window.Shopify;
      if (S && S.customerPrivacy) return cb(S.customerPrivacy);
      if (S && typeof S.loadFeatures === 'function') {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err || !window.Shopify || !window.Shopify.customerPrivacy) return;
          cb(window.Shopify.customerPrivacy);
        });
      }
    }

    flagSet() {
      try { return localStorage.getItem(CHOICE_KEY) === '1'; } catch (e) { return false; }
    }

    setFlag() {
      try { localStorage.setItem(CHOICE_KEY, '1'); } catch (e) { /* ignore */ }
    }

    hasExplicitConsent(cp) {
      try {
        var c = (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
        var vals = [c.marketing, c.analytics, c.preferences, c.sale_of_data];
        if (vals.some(function (v) { return v === 'yes'; })) return true; // accepted something
        if (vals.every(function (v) { return v === 'no'; })) return true;  // fully declined
      } catch (e) { /* ignore */ }
      return false;
    }

    hasDecided(cp) {
      return this.flagSet() || this.hasExplicitConsent(cp);
    }

    regionRequiresConsent(cp) {
      try { if (typeof cp.isRegulationEnforced === 'function') return cp.isRegulationEnforced(); } catch (e) { /* */ }
      try { if (typeof cp.shouldShowBanner === 'function') return cp.shouldShowBanner(); } catch (e) { /* */ }
      return false;
    }

    init(cp) {
      if (this.hasDecided(cp) || !this.regionRequiresConsent(cp)) return;
      this.show();

      var self = this;
      var on = function (sel, fn) {
        var el = self.querySelector(sel);
        if (el) el.addEventListener('click', fn);
      };

      var setConsent = function (o) {
        var payload = {
          analytics: !!o.analytics,
          marketing: !!o.marketing,
          preferences: !!o.preferences,
          sale_of_data: !!o.marketing,
        };
        var done = false;
        var finish = function () { if (!done) { done = true; self.setFlag(); self.hide(); } };
        try {
          cp.setTrackingConsent(payload, finish);
        } catch (e) {
          finish();
        }
        setTimeout(finish, 1000); // safety net if the callback never fires
      };

      on('[data-cookie-accept]', function () {
        setConsent({ analytics: true, marketing: true, preferences: true });
      });
      on('[data-cookie-decline]', function () {
        setConsent({ analytics: false, marketing: false, preferences: false });
      });

      var prefs = this.querySelector('[data-cookie-prefs]');
      var manageBtn = this.querySelector('[data-cookie-manage]');
      var saveBtn = this.querySelector('[data-cookie-save]');
      on('[data-cookie-manage]', function () {
        if (prefs) prefs.hidden = false;
        if (manageBtn) manageBtn.hidden = true;
        if (saveBtn) saveBtn.hidden = false;
      });
      on('[data-cookie-save]', function () {
        var checked = function (cat) {
          var el = self.querySelector('[data-cookie-category="' + cat + '"]');
          return !!(el && el.checked);
        };
        setConsent({
          analytics: checked('analytics'),
          marketing: checked('marketing'),
          preferences: checked('preferences'),
        });
      });
    }

    show() {
      this.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('is-visible'); });
    }

    hide() {
      this.classList.remove('is-visible');
      var self = this;
      var ended = false;
      var done = function () { self.hidden = true; };
      this.addEventListener('transitionend', function h() {
        ended = true;
        self.removeEventListener('transitionend', h);
        done();
      });
      setTimeout(function () { if (!ended) done(); }, 400);
    }
  }

  customElements.define('ivb-cookie-consent', IvbCookieConsent);
})();
